import createParent from './create'
import deleteParent from './delete'
import fetchParents from './fetch'
import inviteParent from './invite'
import updateParent from './update'

export default {
  fetchParents,
  inviteParent,
  updateParent,
  deleteParent,
  createParent,
}
